import { useQuery } from "@tanstack/react-query"
import { isValidVaultSessionQueryOptions } from "src/auth/auth.model"
import { useParams } from "react-router"

/**
 * NOTE when adding this that you should avoid adding it to globally accessible links
 * LIKE PREVIEWS
 */
export default function CheckValidVaultSession(): null {
  const { vaultId } = useParams()
  useQuery(isValidVaultSessionQueryOptions({ vaultId: vaultId as string }))
  return null
}
